import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../common/services/user.service';
import { TechnicalserviceCompanyService } from '../../../configuration/services/technicalservice-company.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';


@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.css'],
  providers:[UserService,TechnicalserviceCompanyService]
})
export class ViewUserComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  user: any = {};
  technicalserviceCompanies: any = [];
  roles:any = [
    {name:"Admin", id:1},
    {name:"Usuario Interno", id:2},
    {name:"Usuario externo", id:3}
  ];

  constructor(private userService: UserService, private technicalserviceCompanyService:TechnicalserviceCompanyService,
              private route: ActivatedRoute, private router: Router, public toastr: ToastsManager, vcr: ViewContainerRef) {
                this.toastr.setRootViewContainerRef(vcr);
               }

  ngOnInit() {
    this.getTechnicalserviceCompanies();
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getUser();
      }
    });
  }
 

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getTechnicalserviceCompanies(){
    this.technicalserviceCompanyService.query({}).subscribe((technicalserviceCompanies)=>{
      this.technicalserviceCompanies = technicalserviceCompanies;
      this.technicalserviceCompanies.unshift({name:"Ninguna", id:-1});
    });
  }


  getUser(){
    this.userService.get(this.id).subscribe((user) => {
      this.user = user;
    });
  }

  saveUser(){
      if (this.user.id == undefined){
        if (this.user.password && this.user.password.length >= 6){
          this.userService.create(this.returnUserProperties(this.user))
          .subscribe((user) => {
            this.userService.get(user.id).subscribe((user) => {
              this.user = user;
              this.router.navigate(['/user/list']);
            });
          });
        }else{
          this.toastr.error('Longitud de contraseña', 'La Contraseña debe tener una longitud de al menos 6 caracteres',{toastLife:2000});
        }
      }else{
        if (!this.user.password || this.user.password.length >= 6){
          this.userService.update(this.returnUserProperties(this.user))
          .subscribe((user) => {
            this.user = user;
            this.router.navigate(['/user/list']);
          });
        }else{
          this.toastr.error('Longitud de contraseña', 'La Contraseña debe tener una longitud de al menos 6 caracteres',{toastLife:2000});
        }
      }
  }

  

  returnUserProperties(user){
    var properties = {
      username: user.username,
      name: user.name,
      surname: user.surname,
      role: user.role,
      technicalservice_company_id: user.technicalservice_company_id	
    }
    if (user.password){
      properties['password'] = user.password;
    }
    if (user.id){
      properties['id'] = user.id;
    }
    return properties;
  }

   
}



// WEBPACK FOOTER //
// ./src/app/user/components/view-user/view-user.component.ts